import React from "react";

import { StyleSheet, Text, View, Button,TextInput, ImageBackground, Dimensions, Linking,Platform } from "react-native"
import imgSrc from './images/endd.png';
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const user_id = urlParams.get('uid');
const Fasla = (props) => {
    
    return(  
			<View style={styles.container}>
			<ImageBackground source={imgSrc}   style={{
				width: Dimensions.get('window').width,
				height: Dimensions.get('window').height,
				resizeMode: "contain",
				alignSelf: "center",
				//borderWidth: 1,
				//borderRadius: 1,
			}}> 
				<View style={styles.buttonContainer}>

                <Button 
                color='#4472C4'
                title="Continue"
                style={StyleSheet.buttonStyle}
				onPress={() => { Linking.canOpenURL('https://clemson.ca1.qualtrics.com/jfe/form/SV_6M8zDb6DO5AqMEm').then(supported => {
					if (supported) {
						Linking.openURL('https://clemson.ca1.qualtrics.com/jfe/form/SV_6M8zDb6DO5AqMEm?PROLIFIC_PID='+user_id);					 
					} else {
					  console.log("Don't know how to open URI: " + 'https://clemson.ca1.qualtrics.com/jfe/form/SV_6M8zDb6DO5AqMEm');
					}
				  }); }}> </Button>
				</View>
				</ImageBackground>
			</View>
			 
       
    )
}
const styles = StyleSheet.create({
	container: {
		padding: 1,
		flex: 1,
		display: "flex",
		marginTop: 1,
		textAlign: 'center',
		flexDirection: "column",
		justifyContent: "center",
        backgroundColor:"#FFFFFF"
		
	},
	buttonContainer:{
		width: '20%',
		alignSelf: 'center',
		marginVertical: 20,
        justifyContent: 'center', 
        alignItems: 'center',
        position: 'absolute',
        bottom: 0
	},

	text: {
		fontWeight: "bold",
		fontSize: 20
	},
	buttonStyle: {
		alignItems: 'center',
	justifyContent: 'center',
	paddingVertical: 12,
	paddingHorizontal: 32,
	borderRadius: 0,
	elevation: 13,
	backgroundColor:"#4472C4"
	},
	listContainer: {
		paddingTop: 20
	},
	listItem: {
		fontSize: 20
	},
	textAreaContainer: {
		
		paddingTop:  Dimensions.get('window').height/1.28,
		paddingRight:Dimensions.get('window').width/6,
		paddingLeft: Dimensions.get('window').width/6,
		paddingBottom: 30,

	  },
	 
	  textArea: {
		//backgroundColor:'#EBECF0',
		backgroundColor:'#EBECF0',
		height: 300,
		fontSize: 23,
		//borderColor: '#000000',
		//borderWidth: 2,
		//backgroundColor:"grey",
		justifyContent: "flex-start"
	  }
})
export default Fasla